<style>
.entity-popover-target {
  position: absolute;
  top: -45px;
  right: 15px;
  z-index: -1;
}
</style>

<template>
  <b-row>
    <b-col>
      <vue-form-generator
        id="app-form-generator"
        :schema="schema.schema"
        :model="model"
        :options="schema.options"
        ref="applicationForm"
      />
      <additional-content
        class="col-md-12"
        v-if="entity"
        :entity="entity"
        ref="additionalContent"
      />
      <div class="w-100 text-right mt-3 col-md-12">
        <verification-user-email
          ref="verificationUserAlertPreview"
          placement="left"
          target="preview-button"
        />
        <b-popover
          v-if="previewDisabled"
          target="preview-container"
          triggers="hover"
          placement="left"
        >
          <template v-slot:title>
            It seems like you still need to fill out the following sections:
          </template>
          <ul class="text-left">
            <li v-for="item in missingItems" v-bind:key="item">
              {{ item | capitalize }}
            </li>
          </ul>
        </b-popover>
        <span id="preview-container">
          <b-button
            class="btn-anchor raised"
            :disabled="previewDisabled"
            id="application-preview-button"
            ref="previewButton"
            @click="preview"
          >
            eSign
          </b-button>
        </span>
      </div>
      <new-entity ref="newEntity" :display-button="false" />
      <verification-user-email
        v-if="popovers.new.display"
        ref="verificationUserAlert"
        placement="leftbottom"
        :target="popovers.new.target"
      />
    </b-col>
  </b-row>
</template>

<script>
import helper from '@/libs/helper';

import VueFormGenerator from 'vue-form-generator';
import NewEntity from '@/components/entities/NewEntity';
import EntityDetails from '@/components/entities/EntityDetails';
import VerificationUserEmail from '@/components/utils/verification/VerificationUserEmail';
import AdditionalContent from '@/components/profile/sections/tabs/application/form/AdditionalContent';

import APPLICATION_SCHEMA from '@/components/profile/sections/tabs/application/form/schema';

const ESIGN = 'esign';
export default {
  components: {
    'vue-form-generator': VueFormGenerator.component,
    NewEntity,
    EntityDetails,
    VerificationUserEmail,
    AdditionalContent,
  },
  data() {
    return {
      popovers: {
        new: {
          display: true,
          target: 'new-entity-app-btn',
        },
      },
      model: { type: 'entity', entity: null },
      esign: false,
    };
  },
  created() {
    if (ESIGN in this.$route.query) this.esign = true;
  },
  mounted() {
    const profile = this.$store.getters.profile;
    if (profile && profile.application) {
      this.model = {
        type: 'entity',
        entity: profile.application.entity,
      };
    }

    if (this.esign) {
      this.model.entity = this.lastEntity;
      this.submitEsign();
    }
  },
  watch: {
    entities(val) {
      if (val.length > 0) {
        this.model.entity = val[val.length - 1].id;
      }
    },
  },
  computed: {
    lastEntity() {
      const entities = this.$store.getters.entities;
      if (entities.length > 0) {
        return entities[entities.length - 1].id;
      }
      return null;
    },
    user() {
      return this.$store.getters.user;
    },
    entities() {
      return this.$store.getters.entities;
    },
    entity() {
      return this.entities.find(entity => entity.id === this.model.entity);
    },
    schema() {
      const entityOptions = this.entities.map(entity => ({
        id: entity.id,
        name: entity.name,
      }));
      const entityRequired = this.model.type === 'entity';
      const customClass = !entityRequired ? ' d-none' : '';
      const newEntityHandler =
        this.user.verified && entityRequired ? this.newEntityClicked : null;

      return {
        schema: APPLICATION_SCHEMA.schema(
          entityOptions,
          entityRequired,
          customClass,
          newEntityHandler,
        ),
        options: APPLICATION_SCHEMA.options,
      };
    },
    missingItems() {
      const missing = helper.copy(this.$store.getters.profile.missing);
      delete missing.social;
      delete missing.application;
      delete missing.finances;
      delete missing.address;
      missing.entity = !this.entity;
      const items = [];
      Object.keys(missing).forEach((key) => {
        if (missing[key] === true) {
          items.push(key);
        }
      });
      return items;
    },
    previewDisabled() {
      const noEntity = !this.entity;
      const missingItems = this.missingItems.length !== 0;
      return noEntity || missingItems;
    },
  },
  methods: {
    newEntityClicked() {
      this.$refs.newEntity.$refs.newEntityModal.show();
    },
    validate() {
      return this.$refs.applicationForm.validate();
    },
    preview() {
      if (this.$refs.verificationUserAlertPreview.isVerified) {
        this.$refs.previewButton.blur();
        this.$emit('submit', this.model);
      }
    },
    submitEsign() {
      setTimeout(() => this.$emit('submit', this.model), 500);
    },
  },
};
</script>



// WEBPACK FOOTER //
// src/components/profile/sections/tabs/application/form/ApplicationForm.vue